import React, { useState, useEffect, useRef } from 'react';
import { animateScroll } from 'react-scroll';
import cn from 'classnames';
import { Link, useHistory } from 'react-router-dom';
import { scroller } from 'react-scroll';

import { StoreContext } from '../../../store';
import DropdownMenu from '../../UIkit/DropdownMenu';
import { getPhone } from '../../../utils/getPhone';
import { getHeaderMenuItems, ID_SECTION } from '../../../store/constants';

import style from './Header.module.css';
import HeaderItem from './HeaderItem';
import { useOutsideClick } from './../../../utils/hooks';

type Prop = {
  isOtherPage?: boolean;
};
function Header({ isOtherPage = false }: Prop): JSX.Element {
  const { contactUs } = React.useContext(StoreContext);
  const { PHONE, PHONE_NORMILIZE } = getPhone();

  const [isOpen, setOpen] = useState(false);
  const [smallHeader, setSmallHeader] = useState(false);

  const listener = (): void => {
    // console.log('listener');
    //   setBodyOffset(document.body.getBoundingClientRect());
    //   setSmallHeader(-bodyOffset.top > 20);
    if (window.scrollY > 20) {
      setSmallHeader(true);
    } else {
      setSmallHeader(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', listener);
    return (): void => {
      window.removeEventListener('scroll', listener);
    };
  });

  function hideMenu(): void {
    setOpen(false);
  }
  function handleToggleClick(): void {
    console.log(isOpen);

    setOpen(!isOpen);
  }

  const history = useHistory();
  function scroll(to: string): void {
    if (isOtherPage) {
      sessionStorage.setItem('mobileScrollTo', to);
      history.push({
        pathname: '/',
        state: { scrollTo: to },
      });
    } else {
      scroller.scrollTo(to, {
        duration: 800,
        smooth: true,
        offset: 0,
      });
    }
  }
  function scrollToTop(): void {
    scroll(ID_SECTION.MAIN.to);
    // animateScroll.scrollToTop();
    // scroller.scrollTo(ID_SECTION.MAIN.to, {
    //   duration: 800,
    //   smooth: true,
    //   offset: 0,
    // });
  }

  const checkScrollRef = useRef<number>();
  const checkScrollPosition = () => {
    const scrollContent = document.querySelector('.scroll-content') as HTMLElement;
    if (scrollContent) {
      const transform = window.getComputedStyle(scrollContent).transform;
      const matrix = transform.match(/^matrix3d\((.+)\)$/);
      let y = 0;
      if (matrix) {
        const values = matrix[1].split(', ');
        y = parseFloat(values[13]);
      } else {
        const matrix2d = transform.match(/^matrix\((.+)\)$/);
        if (matrix2d) {
          const values = matrix2d[1].split(', ');
          y = parseFloat(values[5]);
        }
      }
      setSmallHeader(y !== 0);
    }
    checkScrollRef.current = requestAnimationFrame(checkScrollPosition);
  };
  useEffect(() => {
    checkScrollRef.current = requestAnimationFrame(checkScrollPosition);
    return () => {
      if (checkScrollRef.current) {
        cancelAnimationFrame(checkScrollRef.current);
      }
    };
  }, []);

  const isWhiteHeader = (!isOtherPage && smallHeader) || isOtherPage;

  const menuRef = useOutsideClick(hideMenu);
  return (
    <header className={cn(style.header, isWhiteHeader && style.small)}>
      <nav className={style.nav} ref={menuRef}>
        <button className={style.logo} onClick={scrollToTop} aria-label="logo" />
        <ul className={cn(style.itemsContainer, style.ulmain, isOpen && style.mobileMenu)}>
          {getHeaderMenuItems().map(item => {
            if (item.isHidden) return;
            if (item.dropdownItems) {
              return (
                <DropdownMenu
                  key={item.to}
                  title={item.label}
                  items={item.dropdownItems}
                  className={cn(style.item, isOpen && style.itemAppear)}
                />
              );
            }
            return (
              <HeaderItem
                key={item.to}
                onClick={hideMenu}
                id={item.id}
                to={item.to}
                scroll={scroll}
                className={cn(style.item, isOpen && style.itemAppear)}
              >
                {item.label}
              </HeaderItem>
            );
          })}
        </ul>
        <div className={style.contacts}>
          <div className={style.phone}>
            <a href={`tel:${PHONE_NORMILIZE}`}>{PHONE}</a>
          </div>
        </div>
        <button className={style.menu} onClick={handleToggleClick} aria-label="toggle" type="button">
          Меню
        </button>
      </nav>
    </header>
  );
}

export default Header;
